import styled from "styled-components";
import { RowFlex } from "@/main/components/shared/styles";
import { Button } from "@mui/material";

export const Container = styled.div``;
export const Header = styled.div`
	position: relative;
	display: flex;
	flex-direction: column;
	margin: 0 0 0.4rem;
	padding-right: 36px;
`;

export const AreaButton = styled.div`
	position: absolute;
	top: 0;
	right: 0;
	display: flex;
	align-items: flex-start;
	gap: 1rem;
	margin-left: auto;

	> button {
		padding: 0.4rem 0.8rem;
		min-width: 90px;
	}

	@media (max-width: 740px) {
		flex-direction: column;
		justify-content: space-between;
		margin-left: 0;

		> button {
			width: 100%;
			max-width: 100%;
		}
	}
`;
export const Content = styled.div``;
export const Footer = styled.div`
	padding: 0 1.1rem;
`;

export const ButtonTrigger = styled(Button)`
	&&& {
		background: none;
		border: none;
		min-width: fit-content;
	}
`;

export const DropdownArea = styled.div`
	border: 1px solid;
	padding: 1rem;
	background-color: #ffff;
`;

export const FooterButtonHistory = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	margin-top: 15px;
	width: 100%;
`;

export const RowInfoOrder = styled.div`
	display: flex;
	flex-direction: row;
	gap: 1rem;
	overflow: hidden;

	@media (max-width: 740px) {
		flex-direction: column;
	}
`;

export const AreaInfoOrder = styled.div`
	display: flex;
	flex-wrap: wrap;
	padding: 0;
	gap: 0.5rem;
	flex: 0 1 auto;
	max-width: 350px;

	@media (max-width: 740px) {
		width: 100%;
		max-width: 100%;
		flex-direction: column;
		gap: 0;
	}
`;

export const AreaInfoBodyshop = styled.div`
	display: flex;
	flex-direction: column;
	gap: 1rem;
	min-width: 0;
	flex: 1;

	@media (max-width: 740px) {
		width: 100%;
	}
`;

export const RowFlexInfoOrder = styled(RowFlex)`
	min-width: 0;
	overflow: hidden;

	& > * {
		min-width: 0;
		overflow: hidden;
	}

	@media (max-width: 740px) {
		justify-content: space-between;
		flex-direction: column;
	}
`;

export const LabelArea = styled.div`
	width: 100%;
`;
export const ContentArea = styled.div`
	width: 100%;
`;

export const LabelText = styled.p`
	font-weight: bold;
	margin: 0;
`;
export const ContentText = styled.p`
	margin: 0;
	width: 100%;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;

	@media (max-width: 740px) {
		text-overflow: unset;
		white-space: unset;
	}
`;

export const ContainerLabelText = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: flex-start;
	align-items: flex-start;
`;

export const AreaGrid = styled.div`
	display: grid;
	grid-template-columns: 1fr 2fr;
	gap: 1rem;

	@media (max-width: ${({ theme }) => theme.breakpoints.desktop}) {
		grid-template-columns: 1fr;
		gap: 0;
	}
`;

interface IGridCssProps {
	columns: number;
}

export const GridCss = styled.div<IGridCssProps>`
	display: grid;
	gap: 0.4rem;
	grid-template-columns: minmax(0, 1fr) repeat(${(props) => props.columns - 1}, minmax(0, 2fr));

	#collumn-deliveryAddres {
		grid-column: span 2;
	}

	@media (max-width: ${({ theme }) => theme.breakpoints.desktop}) {
		grid-template-columns: 1fr;

		#collumn-deliveryAddres {
			grid-column: span 1;
		}
	}
`;
